export default __webpack_public_path__ + "94691e1c5852e529b15945d47a765fc2.svg";